// "use strict";
import burger from "./modules/burger.js";
import adaptiveElements from "./modules/adaptiveElements.js";
import productItemPage from "./productPage/productItemPage.js";
import {Modal} from "./modules/popups.js";
import catalogPage from "./catalogPage/catalogPage.js";
import focusWithLabel from "./modules/focusWithLabel.js";
import handleMarquee, {handleMarquee1} from "./modules/handleMarquee.js";
import pageHomePage from "./homePage/homePage.js";
import menu from './modules/menu.js';
import checkout from "./modules/checkout.js";
import logicElements from "./modules/logicElements.js";
import cart from "./modules/cart.js";
import {header} from "./modules/elements.js";
import loginPage from "./modules/loginPage.js";
import tabs from "./modules/tabs.js";
import userPage from "./modules/userPage.js";
import {getElement, lenghtCorrect} from "./modules/helpers.js";
import {blogRelatedSlider, rewardPageSlider} from "./modules/sliders.js";
import {findVariation} from "./productPage/renderProductInfo.js";
import userMembership from './modules/userMembership.js'
import {modalEvents} from "./modules/modalFunctions.js";
import catalogItem, {catalogItemSlider} from "./catalogItem/catalogItem.js";
import catalogSliders from "./catalogPage/catalogSliders.js";
import filter from "./catalogPage/filter.js";

productItemPage();
window.addEventListener("DOMContentLoaded", () => {
    try {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');

        window.addEventListener('resize', function () {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
        });
        window.addEventListener('scroll', function () {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
        });

        if (location.href.includes('#cart')) {
            setTimeout(() => {
                modalEvents(getElement('#cart'));
            }, 100)
        }
        userMembership()
        menu();
        burger();
        adaptiveElements();
        checkout();
        logicElements();
        cart();
        catalogPage();
        pageHomePage();
        loginPage();
        userPage();
        blogRelatedSlider();
        rewardPageSlider();
        if (document.querySelector(".catalog-promo")) {

            catalogItem(promoProducts);
            document.querySelectorAll('[data-catalog-item]').forEach(itemCatalog => {
                const gallery = itemCatalog.querySelector('.catalog-item__gallery');
                itemCatalog.querySelectorAll('.catalog-item__image').forEach(catalogItemImage => {
                    catalogItemImage.querySelector('img').classList.add('swiper-lazy');
                })
                catalogItemSlider(gallery.dataset.swiper)
            })
            // catalogSliders();
        }
        //Input module
        const inputsLabel = document.querySelectorAll('[data-input="label"]');
        inputsLabel.forEach((item) => {
            focusWithLabel(item);
        });
        if (getElement('[data-blog-description]')) {
            getElement('[data-blog-description]', true).forEach(item => {
                item.innerText = lenghtCorrect(item.innerText, 179);
            })
        }
        if (getElement('.cookies')) {
            setTimeout(() => {
                if (!localStorage.getItem('cookies', 'accept') || localStorage.getItem('cookies', 'accept') !== 'accept') {
                    getElement('.cookies').classList.remove('hide')
                    getElement('.cookies').classList.add('show')
                }

            }, 3500)
            getElement('[data-cookies]', true).forEach(item => {
                item.addEventListener('click', () => {
                    getElement('.cookies').classList.remove('show');
                    getElement('.cookies').classList.add('hide');
                    if (+item.dataset.cookies) {
                        localStorage.setItem('cookies', 'accept');
                    }
                })
            })
        }

        if (getElement('.form__item')) {

            document.querySelectorAll('.form__item').forEach(item => {

                if (item.querySelector('input')) {
                    if (item.querySelector('.wpcf7-form-control-wrap')) {
                        item.querySelector('input').addEventListener('focusin', function () {
                            item.querySelector('label').classList.add('focus')


                        })
                        item.querySelector('input').addEventListener('focusout', function () {
                            item.querySelector('label').classList.remove('focus')

                        })

                    }

                    if (item.querySelector('input').value.length > 0) {
                        item.classList.add('not-empty')
                    }
                    item.querySelector('input').addEventListener('input', function () {
                        if (this.value.length >= 1) {
                            item.classList.add('not-empty')
                        } else {
                            item.classList.remove('not-empty')
                        }
                    })
                }
                if (item.querySelector('textarea')) {
                    if (item.querySelector('.wpcf7-form-control-wrap')) {
                        item.querySelector('textarea').addEventListener('focusin', function () {
                            item.querySelector('label').classList.add('focus')

                        })
                        item.querySelector('textarea').addEventListener('focusout', function () {
                            item.querySelector('label').classList.remove('focus')
                        })
                    }


                    if (item.querySelector('textarea').value.length > 0) {
                        item.classList.add('not-empty')
                    }
                    item.querySelector('textarea').addEventListener('input', function () {
                        if (this.value.length >= 1) {
                            item.classList.add('not-empty')
                        } else {
                            item.classList.remove('not-empty')
                        }
                    })

                }


            })
        }

        //poppup module

        //Toggle Switch module
        const toggleSwitch = document.querySelectorAll(".toggle__switch");
        toggleSwitch.forEach((item) => {
            item.addEventListener("click", () => {
                item.classList.toggle("active");
            });
        });

        //Toggle Switch module

        //Module smoothHeight

        const smoothHeight = (itemSelector, buttonSelector, contentSelector) => {
            const items = document.querySelectorAll(itemSelector);

            if (!items.length) return;
            items.forEach((el) => {
                const button = el.querySelector(buttonSelector);
                const content = el.querySelector(contentSelector);
                button.addEventListener("click", () => {
                    if (el.dataset.open !== "true") {
                        el.dataset.open = "true";
                        content.style.maxHeight = `${content.scrollHeight}px`;
                        button.classList.add("active");
                    } else {
                        el.dataset.open = "false";
                        content.style.maxHeight = "";
                        button.classList.remove("active");
                    }
                });
                const onResize = () => {
                    if (el.dataset.open === "true") {
                        if (parseInt(content.style.maxHeight) !== content.scrollHeight) {
                            content.style.maxHeight = `${content.scrollHeight}px`;
                        }
                    }
                };
                window.addEventListener("resize", onResize);
            });
        };

        smoothHeight(".table-item", ".table-item__header", ".table-item__content");

        //Module smoothHeight

        //Module tabs


        tabs(
            '[data-tabs="tech"]',
            ".tabs__nav",
            ".tabs__body",
            ".tabs__btn",
            "active",
            "show"
        );
        tabs(
            '[data-tabs="galerry"]',
            ".tabs__nav",
            ".tabs__body",
            ".tabs__btn",
            "active",
            "show"
        );
        tabs(
            '[data-tabs="configuration-section"]',
            ".tabs__nav",
            ".tabs__body",
            ".tabs__btn",
            "active",
            "show"
        );
        //Module tabs
        document.querySelectorAll(".checkbox").forEach((item) => {
            item.addEventListener("click", () => {
                item.classList.toggle("active");
            });
        });
        document.querySelectorAll("[data-modal]").forEach((btn) => {
            btn.addEventListener("click", () => {


                new Modal(".modal", btn.parentNode.closest('[data-product-id]')).openModal(btn.dataset.modal);
            });
        });


        headerFixed();
        addEventListener('scroll', () => {
            headerFixed();
        })
        if (getElement('.black-friday')) {
            handleMarquee1(getElement('.black-friday-marquee'))
            getElement('main').style.paddingTop = getElement('.black-friday').closest('.header').clientHeight + 'px'

        }

        function headerFixed() {
            if (document.querySelector(".header--white")) {
                if (
                    scrollY >
                    document.querySelector(".header--white").offsetHeight
                ) {
                    document.querySelector(".header--white").classList.add("--decor");
                } else {
                    document.querySelector(".header--white").classList.remove("--decor");
                }
            }
            if (scrollY > 10) {
                header.classList.add("header--fixed");
            } else {
                header.classList.remove("header--fixed");
            }
        }
    } catch (e) {
        console.log(e);
    }
});
filter();
